"use client";

import type { ReactNode } from "react";
import * as stylex from "@stylexjs/stylex";
import { styles } from "./onboarding-room.styles";

export function OnboardingRoom({
  title,
  children,
}: Readonly<{
  title: string;
  children: ReactNode;
}>) {
  return (
    <main {...stylex.props(styles.room)}>
      <div {...stylex.props(styles.inset)}>
        <div {...stylex.props(styles.column)}>
          <h1 {...stylex.props(styles.heading)}>{title}</h1>
          {children}
        </div>
      </div>
    </main>
  );
}
